export default __webpack_public_path__ + "static/media/bano-desktop.54e7ea02.png";